import { put, del, post, get } from "../../http";
import { root } from "../../config.json";

export const getPatients = (id) => {
    return get(`${root}/api/v1/hospital/HPatients/${id}`);
  };